<template>
  <footer class="footer">
    <div class="footer-section">
      <div class="wrapper">
        <div class="left">
          <router-link to="/" class="logo">
            <img src="./../images/logo.svg" class="img" />
          </router-link>
          <div class="desc">
            {{ $parent.settings.requisites }}
          </div>
          <div class="desc">
            {{ $parent.settings.copyright }}
          </div>
        </div>
        <div class="right">
          <div class="column">
            <div class="desc">
              <span>
                <b>{{ $t('LEGAL') }}</b>
              </span>
            </div>
            <ul class="nav" v-if="$parent.textPageList.length">
              <template v-for="item in $parent.textPageList">
                <li class="nav__item" :key="item.id">
                  <div @click="$parent.goToPage(item.id)" class="desc">
                    {{ item.title }}
                  </div>
                </li>
              </template>
            </ul>
          </div>
          <div class="column">
            <div class="desc">
              <span>
                <b>{{ $t('GET HELP') }}</b>
              </span>
            </div>
            <ul class="nav">
              <li class="nav__item">
                <router-link to="/faq" class="desc" v-text="$t('FAQ')" />
              </li>
              <li class="nav__item">
                <router-link
                  to="/contacts"
                  class="desc"
                  v-text="$t('CONTACT US')"
                />
              </li>
            </ul>
            <ul class="methods">
              <li
                v-for="(item, idx) in footerImagesToRender"
                :key="'footer-image-' + idx"
                class="methods__item"
              >
                <img
                  :src="item.url"
                  class="img"
                  :style="item.height ? { height: item.height + 'px' } : null"
                />
              </li>
              <template v-if="!footerImagesToRender.length">
                <li class="methods__item">
                  <img src="./../images/methods/visa.svg" class="img" />
                </li>
                <li class="methods__item">
                  <img src="./../images/methods/3ds.svg" class="img" />
                </li>
                <li class="methods__item">
                  <img src="./../images/apple-pay.svg" class="img" />
                </li>
                <li class="methods__item google">
                  <img src="./../images/google-pay.svg" class="img" />
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: [],
  data: function () {
    return {};
  },
  computed: {
    footerImagesToRender() {
      const settings =
        this.$parent && this.$parent.settings ? this.$parent.settings : {};
      const images =
        settings && Array.isArray(settings.footer_images)
          ? settings.footer_images
          : [];
      return images.filter((item) => item && item.url);
    },
  },
  methods: {
    scrollToSection(section) {
      this.$emit("scrollToSection", section);
    },
    setStableDiffusionModel() {
      let model = this.$parent.models.find((obj) => obj.id === 1);
      this.$emit("setActiveModel", model);
    },
  },
  mounted() {},
};
</script>

<style scoped>
.methods {
  flex-wrap: wrap;
}
</style>
